import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'ps-pm-create-comment',
  templateUrl: 'pm-create-comment.component.html'
})
export class PmCreateCommentComponent {

  comment: string;

  constructor(private dialogRef: MatDialogRef<any>) {
  }

  save() {
    this.dialogRef.close(this.comment);
  }

  dismiss() {
    this.dialogRef.close();
  }
}
